export const Theme: Record<string, string> = {
  ColorBackgroundPrimary: '#f5f5f5',
  ColorBackgroundSecondary: '#fff',
  ColorBackgroundWithLogo: '#ee4d2d',
  ColorPrimary: '#ee4d2d',
  ColorLink: '#1492fd',
  ColorError: '#ee2c4a',
};

export default Theme;
